import {
  Package,
  Users,
  Warehouse,
  Receipt,
  Wallet,
  BellRing,
} from 'lucide-react'

export default function GetStartedSection() {
  const steps = [
    {
      icon: Package,
      title: '1. Ajoutez vos produits',
      desc: 'Créez vos articles, prix et catégories. Vous pouvez aussi importer vos produits via CSV.',
    },
    {
      icon: Warehouse,
      title: '2. Organisez votre stock',
      desc: 'Créez vos dépôts et conteneurs pour organiser votre inventaire et suivre les mouvements.',
    },
    {
      icon: Users,
      title: '3. Ajoutez vos clients',
      desc: 'Conservez les coordonnées de vos clients pour facturer et suivre les paiements.',
    },
    {
      icon: Receipt,
      title: '4. Émettez vos factures',
      desc: 'Enregistrez vos ventes et visualisez immédiatement ce que chaque client doit.',
    },
    {
      icon: Wallet,
      title: '5. Enregistrez les paiements',
      desc: 'Paiement complet, partiel ou trop-perçu : tout est suivi automatiquement.',
    },
    {
      icon: BellRing,
      title: '6. Activez les relances',
      desc: 'Automatisez les rappels pour les clients qui ont des factures non réglées.',
    },
  ]

  return (
    <section className='mx-auto max-w-7xl px-4 py-20'>
      <div className='text-center max-w-2xl mx-auto'>
        <h2 className='text-3xl font-bold tracking-tight'>
          Bien démarrer avec MOGESAPP
        </h2>
        <p className='text-muted-foreground mt-2'>
          Suivez cet ordre simple pour mettre en place votre gestion commerciale
          sans vous perdre.
        </p>
      </div>

      <div className='mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6'>
        {steps.map((step) => {
          const Icon = step.icon
          return (
            <div
              key={step.title}
              className='rounded-xl border p-6 hover:shadow-md transition'
            >
              <div className='flex items-center gap-3'>
                <div className='p-2 rounded-md bg-primary/10'>
                  <Icon className='h-5 w-5 text-primary' />
                </div>
                <div className='font-semibold'>{step.title}</div>
              </div>

              <p className='text-sm text-muted-foreground mt-3'>{step.desc}</p>
            </div>
          )
        })}
      </div>

      <div className='mt-12 rounded-xl border bg-muted/40 p-6 max-w-3xl mx-auto'>
        <div className='font-semibold mb-2'>Conseil</div>
        <p className='text-sm text-muted-foreground'>
          Commencez par configurer vos produits, votre stock et vos clients. Une
          fois ces éléments en place, la facturation et le suivi des paiements
          deviennent très simples.
        </p>
      </div>
    </section>
  )
}
